import { Button } from "@/components/Button"
import { ReactComponent as ChargedIcon } from "@/Images/icons/Charged.svg"
import { FormattedMessage } from "react-intl"
import { useHistory } from "react-router-dom"
export const Charged = ({ title }: { title?: string }) => {
  const history = useHistory()
  return (
    <div className="charged">
      <ChargedIcon />
      <h1>{title ?? <FormattedMessage id="charged" />}</h1>
      <p>
        <FormattedMessage id="exchange-done" />
      </p>
      <Button className="mt-[20px]" variant="outlined" onClick={() => history.push("/")}>
        <FormattedMessage id="go-to-area" />
      </Button>
    </div>
  )
}
